module.exports = __webpack_public_path__ + "media/images/players/DECHAMBEAU_BRYSON-65aff12c7891d62f24c6a65b1d1556fb.png";